"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
exports.fadein = (x, y) => styled_components_1.keyframes `
  from {
    opacity: 0;
    transform: translate(${x}px, ${y}px);
  };
  to { opacity: 1; };
`;
exports.FadeinSection = styled_components_1.default.div `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    ${props => props.isVisible && `animation: ${exports.fadein(0, 15)} 800ms ease-in-out`};
    opacity: ${props => (props.isVisible ? 1 : 0)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Animations.ts